import React from 'react';
import ReactDOM from 'react-dom/client';
import 'regenerator-runtime/runtime';
import App from './App';

// Styles and assets
import 'assets/scss/style.scss';

// Context and Redux
import { ConfigProvider } from 'contexts/ConfigContext';
import { Provider } from 'react-redux';
import { persister, store } from 'store';

// Third-party libraries
import { BrowserRouter } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';

// ==============================|| ZENDESK WIDGET INJECTION ||============================== //
if (import.meta.env.VITE_ENABLE_ZENDESK === 'true') {
  const script = document.createElement('script');
  script.id = 'ze-snippet';
  script.src = 'https://static.zdassets.com/ekr/snippet.js?key=848501ce-cf7e-4920-ae68-cbd5e4a67650';
  script.async = true;
  document.body.appendChild(script);

  script.onload = () => {
    if (typeof (window as any).zE === 'function') {
      // Optionally hide the widget or perform other actions
      (window as any).zE('webWidget', 'hide');
    }
  };
}

// ==============================|| REACT DOM RENDER ||============================== //

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
          <BrowserRouter>
            <ConfigProvider>
              <App />
            </ConfigProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}
